<div *ngIf="sabreText$ | async as sabreText">
  <div *ngIf="sabreText.response" class="text-size-container">
    <div>
      <button mat-icon-button color="primary" (click)="onCloseDialog()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div>
      <button mat-icon-button (click)="onFitToScreen()">
        <mat-icon>fit_screen</mat-icon>
      </button>
      <button mat-icon-button (click)="onIncreaseFontSize()">
        <mat-icon>text_increase</mat-icon>
      </button>
      <button mat-icon-button (click)="onDecreaseFontSize()">
        <mat-icon>text_decrease</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="sabre-text">
    <div class="flex-center" *ngIf="sabreText.isLoading && !sabreText.response">
      <mat-spinner color="accent" diameter="32" class="spinner"></mat-spinner>
    </div>
    <pre *ngIf="sabreText.response?.lines as lines" [ngStyle]="{ 'font-size': fontSizePx.toFixed(1) + 'px' }">
      <div *ngFor="let line of sabreText?.response?.lines" [ngClass]="line.classes || ''">{{ line.text }}</div>
    </pre>
  </mat-dialog-content>

  <div *ngIf="data.refreshFn" class="data-status">
    <app-data-status [timestamp]="sabreText.response?.timestamp" [isLoading]="sabreText.isLoading"
      (refresh)="onRefreshClick()"></app-data-status>
  </div>
  <mat-progress-bar *ngIf="sabreText.isLoading" color="accent" mode="indeterminate"></mat-progress-bar>
</div>